module.exports = __webpack_public_path__ + "1de8b92872a5125223979d38f0b00cf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/news/Kids_families_2.jpg
// module id = 867
// module chunks = 0